<template>
  <div>
    <div v-show="loading">
      <Loading />
    </div>
    <div v-if="errored">
      <ErrorPage />
    </div>
    <div v-else-if="notfound">
      <NotFound titulo="Produto" />
    </div>
    <div
      v-else-if="dadosProduto != null"
      class="food-page-section content-size section-home-noradius"
    >
      <div class="wrap-food-recipe">
        <div class="heading-page-item">DETALHES DO ITEM</div>

        <div class="section-news-page">
          <div class="news-wrap">
            <div v-if="
                exibeImagem(dadosProduto.imagem)
              ">
              <Imagem :caminhoImagem="dadosProduto.imagem"></Imagem>
            </div>
            <div class="rd-tab">
              <ul class="nav nav-tabs" role="tablist" style="padding-top: 10px">
                <li class="nav-item">
                  <a
                    @click="tabs='descricao'"
                    :class="(tabs === 'descricao') ? 'nav-link active' : 'nav-link'"
                    role="tab"
                    aria-selected="true"
                    aria-controls="descricao"
                    id="desc"
                  >Descrição</a>
                </li>
                <!-- <li class="nav-item">
                  <a
                    @click="tabs='comentarios'"
                    :class="(tabs === 'comentarios') ? 'nav-link active' : 'nav-link'"
                    role="tab"
                    aria-selected="false"
                    aria-controls="comentarios"
                    id="coments"
                    tabindex="-1"
                  >Comentários (0)</a>
                </li>-->
              </ul>
              <div class="tab-content">
                <div
                  v-if="tabs === 'descricao'"
                  :class="(tabs === 'descricao') ? 'tab-pane active' : 'tab-pane fade'"
                >
                  <h4>{{ dadosProduto.nome }}</h4>
                  <div v-if="dadosProduto.pais.nome != null">
                    <img
                      class="img-flag"
                      :src="'/img/flags/' + dadosProduto.pais.icone"
                      :alt="dadosProduto.pais.nome"
                    />
                    <span class="text-country">{{ dadosProduto.pais.nome }}</span>
                  </div>
                  <p class="news-content">{{ dadosProduto.descricao }}</p>
                  <h6
                    class="more"
                  >{{ dadosProduto.legendaPrecoAPartir && !dadosProduto.pais.nome ? dadosProduto.legendaPrecoAPartir : ""}} R$ {{ formatarPreco(dadosProduto.preco) }}</h6>
                  <div class="wrap-list-rc">
                    <div class="lrc-button">
                      <div class="lrcb-left">
                        <!-- <span class="lhc like">
                          <font-awesome-icon :icon="['far', 'thumbs-up']" size="2x" />0
                        </span>-->
                        <!-- <span class="lhc like">
                          <font-awesome-icon :icon="['far', 'thumbs-down']" size="2x" />0
                        </span>
                        <span class="lhc comment">
                          <font-awesome-icon :icon="['far', 'comment-dots']" size="2x" />0
                        </span>-->
                      </div>
                      <div class="lrcb-right"></div>
                      <div class="clear"></div>
                    </div>
                  </div>
                  <div v-if="dadosProduto.itens.length > 0">
                    <div>
                      <hr />
                      <h6>{{ (dadosProduto.legendaItens) ? dadosProduto.legendaItens : "Escolha uma opção" }}</h6>
                    </div>
                    <div
                      v-for="(item, i) in dadosProduto.itens"
                      :key="i"
                      class="produto-item-block"
                    >
                      <div class="item-title">
                        {{ item.nome }}
                        <br />
                        <span class="item-desc">{{ item.descricao }}</span>
                      </div>
                      <div
                        class="item-price"
                        v-if="item.preco != null"
                      >R$ {{ formatarPreco(item.preco) }}</div>
                    </div>
                  </div>
                </div>
                <!-- <div
                  v-if="tabs === 'comentarios'"
                  :class="(tabs === 'comentarios') ? 'tab-pane active' : 'tab-pane fade'"
                >
                  <div class="tab-comment">
                    <div class="add-new-comment">
                      <textarea class="input your-msg" placeholder="Digite sua mensagem aqui..."></textarea>
                      <button type="submit" class="btn btn-primary btn-sm">Enviar</button>
                    </div>
                    <div class="comment-list">
                      <div class="section-comment">
                        <div class="comment-view-body">
                          <div class="cm-row">
                            <div class="cm-img">
                              <img src="/img/profile5.jpg" alt="profile" />
                            </div>
                            <div class="cm-comment">
                              <div class="cmc-heading">
                                <a class="float-left cm-name" href="#">
                                  <strong>Michel</strong>
                                </a>
                                <p class="float-right cm-hour">15 minutos atrás</p>
                                <div class="clear"></div>
                              </div>
                              <div class="cm-content">Recomendo, gostei muito, leve e saboroso.</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorPage from "@/components/template/ErrorPage";
import NotFound from "@/components/template/NotFound";
import Loading from "@/components/template/Loading";
import Imagem from "@/components/Imagem";

export default {
  name: "Cardapios-ProdutoDetalhe",
  components: {
    ErrorPage,
    NotFound,
    Loading,
    Imagem
  },

  data() {
    return {
      dadosProduto: null,
      loading: false,
      errored: false,
      notfound: false,
      tabs: "descricao"
    };
  },

  watch: {
    stateDadosEstabelecimento() {
      this.obterDadosItensProdutos();
    }
  },

  computed: {
    stateDadosEstabelecimento() {
      return this.$store.state.dadosEstabelecimento
    },
  },

  created() {
    if (this.stateDadosEstabelecimento)
      this.obterDadosItensProdutos();
  },

  methods: {
    async obterDadosItensProdutos() {
      const produtosLista = [];
      const produtoArray = this.$route.params.produtoArray;

      if (!produtoArray) {
        this.$router.push({
          name: "Cardapios-Home",
          params: {
            nomeUrl: this.$route.params.nomeUrl
          }
        });
        return;
      }

      const resRef = this.$firebase
        .firestore()
        .collection("estabelecimentos")
        .doc(this.stateDadosEstabelecimento.estabelecimentoId);

      await resRef
        .collection("categorias")
        .doc(produtoArray.categoriaId)
        .collection("produtos")
        .doc(produtoArray.id)
        .collection("itens")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            produtosLista.push({
              nome: doc.data().nome,
              descricao: doc.data().descricao,
              preco: doc.data().preco
            });
          });
        })
        .catch(err => {
          console.log("Erro Firebase (obterDadosItensProdutos)", err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));

      this.dadosProduto = produtoArray;
      this.dadosProduto.itens = produtosLista.sort((a, b) => (a.preco > b.preco) ? 1 : (a.preco < b.preco) ? -1 : 0);
    },
    formatarPreco(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    exibeImagem(caminhoImagem) {
      if (caminhoImagem != null && caminhoImagem != "") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style></style>
